import { Bell } from '@phosphor-icons/react';
import { PlaceCard, type PlaceCardPlace } from '../../places';
import Empty from '../../../shared/components/Empty';
import PageHeader from '../../../shared/components/PageHeader';
import { formatDate } from '../../../shared/utils/date';

type NotificationEntry = {
  place: PlaceCardPlace & { createdAt?: unknown };
  unread: boolean;
};

type NotificationsPageProps = {
  notifications: NotificationEntry[];
  favorites: string[];
  toggleFavorite: (placeId: string) => void;
  onOpen: (place: NotificationEntry['place']) => void;
  t: Record<string, string> & { locale: string };
};

export default function NotificationsPage({
  notifications,
  favorites,
  toggleFavorite,
  onOpen,
  t,
}: NotificationsPageProps) {
  return (
    <PageHeader
      className="favorites-page notifications-page"
      eyebrow={t.notificationsEyebrow}
      title={t.notifications}
      subtitle={t.notificationsSubtitle}
    >
      <div className="card-grid">
        {notifications.map(({ place, unread }) => (
          <PlaceCard
            key={place.id}
            className={`notification-card ${unread ? 'is-unread' : 'is-read'}`}
            place={place}
            favorite={favorites.includes(place.id)}
            favoriteLayout
            detailLabel={formatDate(place.createdAt, t.locale)}
            onToggle={() => toggleFavorite(place.id)}
            onOpen={() => onOpen(place)}
            t={t}
          />
        ))}
        {!notifications.length && (
          <Empty
            icon={Bell}
            title={t.notificationsEmpty}
            text={t.notificationsEmptyText}
          />
        )}
      </div>
    </PageHeader>
  );
}
